package org.moxultimate.topwithmox.dashboard

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.*
import org.moxultimate.topwithmox.components.buttons.GradientButton
import org.moxultimate.topwithmox.components.image.SocialIcon
import org.moxultimate.topwithmox.components.texts.DescriptionText
import org.moxultimate.topwithmox.components.texts.TitleText
import org.moxultimate.topwithmox.navigation.rememberAppNavigator
import org.moxultimate.topwithmox.statics.DashboardStatics.ABOUT_BUTTON
import org.moxultimate.topwithmox.statics.DashboardStatics.ABOUT_CONNECT_TEXT
import org.moxultimate.topwithmox.statics.DashboardStatics.ABOUT_DESCRIPTION
import org.moxultimate.topwithmox.statics.DashboardStatics.ABOUT_EMAIL
import org.moxultimate.topwithmox.statics.DashboardStatics.ABOUT_EMAIL_TEXT
import org.moxultimate.topwithmox.statics.DashboardStatics.ABOUT_TITLE
import org.moxultimate.topwithmox.statics.DashboardStatics.IMG_CURVED_WOOD_BOTTOM
import org.moxultimate.topwithmox.statics.DashboardStatics.IMG_CURVED_WOOD_TOP
import org.moxultimate.topwithmox.statics.DashboardStatics.SOCIAL_EMAIL_ICON
import org.moxultimate.topwithmox.statics.DashboardStatics.SOCIAL_EMAIL_LINK
import org.moxultimate.topwithmox.statics.DashboardStatics.SOCIAL_FACEBOOK_ICON
import org.moxultimate.topwithmox.statics.DashboardStatics.SOCIAL_FACEBOOK_LINK
import org.moxultimate.topwithmox.statics.DashboardStatics.SOCIAL_INSTAGRAM_ICON
import org.moxultimate.topwithmox.statics.DashboardStatics.SOCIAL_INSTAGRAM_LINK
import org.moxultimate.topwithmox.statics.DashboardStatics.SOCIAL_MAIL_ICON
import org.moxultimate.topwithmox.statics.DashboardStatics.SOCIAL_TIKTOK_ICON
import org.moxultimate.topwithmox.statics.DashboardStatics.SOCIAL_TIKTOK_LINK
import org.moxultimate.topwithmox.statics.DashboardStatics.SOCIAL_YOUTUBE_ICON
import org.moxultimate.topwithmox.statics.DashboardStatics.SOCIAL_YOUTUBE_LINK


@OptIn(DelicateApi::class)
@Composable
fun AboutSection() {
    val breakpoint = rememberBreakpoint()

    when (breakpoint) {
        Breakpoint.ZERO, Breakpoint.SM, Breakpoint.MD -> AboutSectionMobile()
        else -> AboutSectionDesktop()
    }
}

@Composable
private fun AboutSectionDesktop() {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(clamp(min = 750.px, value = 65.vh, max = 1100.px))
            .styleModifier {
                property("background-image", "url('$IMG_CURVED_WOOD_TOP')")
                property("background-size", "cover")
                property("background-position", "center")
                property("background-repeat", "no-repeat")
            },
        contentAlignment = Alignment.Center
    ) {

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .height(100.percent)
        ) {
            Image(
                src = IMG_CURVED_WOOD_TOP,
                modifier = Modifier
                    .fillMaxWidth()
                    .height(50.percent)
                    .display(DisplayStyle.Block)
                    .attrsModifier { attr("loading", "lazy") }
            )
            Image(
                src = IMG_CURVED_WOOD_BOTTOM,
                modifier = Modifier
                    .fillMaxWidth()
                    .height(50.percent)
                    .display(DisplayStyle.Block)
                    .attrsModifier { attr("loading", "lazy") }
            )
        }

        Row(
            modifier = Modifier
                .width(clamp(min = 1100.px, value = 80.vw, max = 2000.px))
                .height(100.percent)
                .padding(top = 80.px),
        ) {
            Box(
                modifier = Modifier
                    .width(30.percent),
                contentAlignment = Alignment.BottomStart
            ) {
                AboutDescription()
            }

            Row(
                modifier = Modifier
                    .width(70.percent),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Box(modifier = Modifier.width(15.percent))
                AboutDisplay()
            }

        }

    }
}


@Composable
private fun AboutDescription() {
    val navigator = rememberAppNavigator()

    Column(
        modifier = Modifier
            .fillMaxWidth(),
        horizontalAlignment = Alignment.Start
    ) {
        Column(
            modifier = Modifier
                .width(22.vw)
                .padding(top = 120.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            TitleText(
                title = ABOUT_TITLE,
                modifier = Modifier.textAlign(TextAlign.Center)
            )

            DescriptionText(
                modifier = Modifier
                    .padding(top = 32.px)
                    .textAlign(TextAlign.Center),
                description = ABOUT_DESCRIPTION
            )

            Box(
                modifier = Modifier.padding(top = 32.px),
            ) {
                GradientButton(
                    text = ABOUT_BUTTON,
                    onClick = { navigator.goToAbout() },
                )
            }
        }
    }
}

@Composable
private fun AboutDisplay() {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = 120.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        DescriptionText(
            description = ABOUT_CONNECT_TEXT,
            modifier = Modifier
                .fillMaxWidth()
                .textAlign(TextAlign.Center)
        )
        Row(
            modifier = Modifier.padding(top = 15.px),
            horizontalArrangement = Arrangement.spacedBy(30.px)
        ) {
            SocialIcon(iconUrl = SOCIAL_FACEBOOK_ICON,  link = SOCIAL_FACEBOOK_LINK,  description = "TopWithMox on Facebook")
            SocialIcon(iconUrl = SOCIAL_INSTAGRAM_ICON, link = SOCIAL_INSTAGRAM_LINK, description = "TopWithMox on Instagram")
            SocialIcon(iconUrl = SOCIAL_YOUTUBE_ICON,   link = SOCIAL_YOUTUBE_LINK,   description = "TopWithMox on YouTube",  wideIcon = true)
            SocialIcon(iconUrl = SOCIAL_TIKTOK_ICON,    link = SOCIAL_TIKTOK_LINK,    description = "TopWithMox on TikTok")
            SocialIcon(iconUrl = SOCIAL_EMAIL_ICON,     link = SOCIAL_EMAIL_LINK,     description = "Email TopWithMox")
        }
        DescriptionText(
            description = ABOUT_EMAIL_TEXT,
            modifier = Modifier
                .fillMaxWidth()
                .padding(top = 30.px, bottom = 15.px)
                .textAlign(TextAlign.Center)
        )
        SocialIcon(iconUrl = SOCIAL_MAIL_ICON, link = SOCIAL_EMAIL_LINK, description = "Email TopWithMox", wideIcon = true)
        DescriptionText(
            description = ABOUT_EMAIL,
            modifier = Modifier
                .fillMaxWidth()
                .padding(bottom = 20.px)
                .textAlign(TextAlign.Center)
        )
    }
}



//----- About Section Mobile -------------------------------------------------------------------------------------------


@Composable
private fun AboutSectionMobile() {
    val navigator = rememberAppNavigator()

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(600.px)
            .styleModifier {
                property("background-image", "url('$IMG_CURVED_WOOD_TOP')")
                property("background-size", "cover")
                property("background-position", "center")
                property("background-repeat", "no-repeat")
            },
        contentAlignment = Alignment.Center
    ) {

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .height(100.percent)
        ) {
            Image(
                src = IMG_CURVED_WOOD_TOP,
                modifier = Modifier
                    .fillMaxWidth()
                    .height(50.percent)
                    .display(DisplayStyle.Block)
                    .attrsModifier { attr("loading", "lazy") }
            )
            Image(
                src = IMG_CURVED_WOOD_BOTTOM,
                modifier = Modifier
                    .fillMaxWidth()
                    .height(50.percent)
                    .display(DisplayStyle.Block)
                    .attrsModifier { attr("loading", "lazy") }
            )
        }

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(top = 20.px, leftRight = 60.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            TitleText(
                title = ABOUT_TITLE,
                modifier = Modifier.textAlign(TextAlign.Center)
            )

            DescriptionText(
                modifier = Modifier
                    .padding(top = 24.px)
                    .textAlign(TextAlign.Center),
                description = ABOUT_DESCRIPTION
            )

            DescriptionText(
                description = ABOUT_CONNECT_TEXT,
                modifier = Modifier
                    .fillMaxWidth()
                    .textAlign(TextAlign.Center)
                    .padding(top = 32.px),
            )

            Row(
                modifier = Modifier.padding(top = 15.px),
                horizontalArrangement = Arrangement.spacedBy(30.px)
            ) {
                SocialIcon(iconUrl = SOCIAL_FACEBOOK_ICON,  link = SOCIAL_FACEBOOK_LINK,  description = "TopWithMox on Facebook")
                SocialIcon(iconUrl = SOCIAL_INSTAGRAM_ICON, link = SOCIAL_INSTAGRAM_LINK, description = "TopWithMox on Instagram")
                SocialIcon(iconUrl = SOCIAL_YOUTUBE_ICON,   link = SOCIAL_YOUTUBE_LINK,   description = "TopWithMox on YouTube",  wideIcon = true)
                SocialIcon(iconUrl = SOCIAL_TIKTOK_ICON,    link = SOCIAL_TIKTOK_LINK,    description = "TopWithMox on TikTok")
                SocialIcon(iconUrl = SOCIAL_EMAIL_ICON,     link = SOCIAL_EMAIL_LINK,     description = "Email TopWithMox")
            }

            Box(
                modifier = Modifier.padding(top = 32.px),
            ) {
                GradientButton(
                    text = ABOUT_BUTTON,
                    disabled = true,
                    onClick = {
                        navigator.goToArchitecturePage()
                    }
                )
            }
        }
    }
}
